import { render, staticRenderFns } from "./DisqualifiedCandidates.vue?vue&type=template&id=d9c5b240&scoped=true"
import script from "./DisqualifiedCandidates.vue?vue&type=script&lang=js"
export * from "./DisqualifiedCandidates.vue?vue&type=script&lang=js"
import style0 from "./DisqualifiedCandidates.vue?vue&type=style&index=0&id=d9c5b240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c5b240",
  null
  
)

export default component.exports